<template>
  <VTable
    :items="dealers"
    :fields="fields"
    :checked-rows="checkedItems"
    :loading="loading"
    :on-toggle-row="onToggleRow"
    :on-toggle-all="onToggleAll"
    :on-input-search="onInputSearch"
    :on-edit-item="onEditItem"
    :on-delete-item="onDeleteItem"
    searchPlaceholder="Search for dealer...."
    hideAddButton
    hover
    striped
    border
    small
    fixed
    dark
  >
    <template #footer>
      <VPagination
        :items-count="itemsCount"
        class="user-manager-card__footer-pagination"
      />
    </template>
  </VTable>
</template>
<script>
import {
  createDealersMixin,
  dealersStore,
} from "@/mixins/dealersMixin";
import { debounce } from "@/utils/debounce";
import moment from 'moment'

export default {
  name: "Dealers",
  mixins: [createDealersMixin()],
  components: {},
  computed:{
    fields() {
      return [
        {
          key: "name",
          label: "name",
          _style: "min-width: 125px",
          _classes: "name"
        },
        {
          key: "dealershipName",
          label: "Dealership",
          _classes: "dealershipName"
        },
        {
          key: "email",
          label: "Email address",
          _classes: "email"
        },
        {
          key: "phone",
          label: "Phone",
          _classes: "phone"
        },
        {
          key: "type",
          label: "Type",
          _classes: "type"
        },
        {
          key: "createdAt",
          label: "Date",
          _classes: "phone"
        },
      ];
    },
    checkedItems() {
      return this[dealersStore.getterTypes.GETTER_CHECKED_ROWS];
    },
    itemsCount() {
      return this[dealersStore.getterTypes.GETTER_DEALERS_COUNT];
    },
    dealers() {
      let arr = this[dealersStore.getterTypes.GETTER_DEALERS];
      if(arr && arr.length > 0){
        for(let i =0; i < arr.length; i++){
          arr[i].createdAt = moment(arr[i].createdAt).format("lll");
          arr[i]['type'] = 'Dealer'
        }
      }
      return arr;
    },
  },
  data: () => {
    return {
      loading: false,
      lastSearchTerm: null,
      searchFn: () => {}
    };
  },
  methods:{
    onToggleRow({ item }) {
      this[dealersStore.mutationTypes.SET_CHECKED_ROW](item);
    },
    onToggleAll(items) {
      this[dealersStore.mutationTypes.SET_CHECKED_ROWS](items);
    },
    onInputSearch(t) {
      this.searchFn(t);
    },
    async loadData() {
      this.loading = true;
      await this[dealersStore.actionTypes.ACTION_LOAD_DEALERS]({
        skip: this.$route.query.skip || 0,
        take: this.$route.query.take || 10,
        search: this.$route.query.search || ''
      })
      this.loading = false
    },
  },
  watch: {
    $route() {
      console.log('Route changed');

      this.loadData()
    }
  },
  async created() {
    this.loadData()
    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        };

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => {});
      },
      200
    );
  }
};
</script>
